import { render, staticRenderFns } from "./SidebarAffiliateMenu.vue?vue&type=template&id=b1514d14"
import script from "./SidebarAffiliateMenu.vue?vue&type=script&lang=js"
export * from "./SidebarAffiliateMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports